import { Column } from 'react-table'
import { columnGenerators } from '../../../../../../_metronic/helpers'

export const header = (isSupplyChainManager = false) => [
  { label: 'S.N', value: 'S.N' },
  {
    label: 'Date',
    value: 'actualProcessDate',
  },

  {
    label: 'Batch id',
    value: 'productionId',
  },
  {
    label: 'Material Hub',
    value: 'pickupPointName',
  },
  // {
  //   label: isSupplyChainManager ? 'Supply chain' : 'Franchisee',
  //   value: 'franchiseName',
  // },
  {
    label: 'Process',
    value: 'processName',
  },
  {
    label: 'Type',
    value: 'processType',
  },
  {
    label: 'Input',
    value: 'inputMaterial',
  },
  {
    label: 'Quantity',
    value: 'inMaterialDetailsQuantity',
  },
  {
    label: 'Output',
    value: 'productionItemDetails',
  },
  {
    label: 'Quantity',
    value: 'productionItemDetailsQuantity',
  },
  {
    label: 'Wastage',
    value: 'wastage',
  },

  /*   {
    action: ['certificate'],
  }, */

  // {
  //   action: ['view_prod_certificate', 'qr'],
  // },
  {
    action: [''],
  },
]
const roleColumns = (isSupplyChainManager = false) => {
  return columnGenerators(header(isSupplyChainManager))
}
export { roleColumns }
